import React from 'react';
import { ContentCollapse } from 'site-modules/shared/components/content-collapse/content-collapse';

export function ComparatorInfoSection() {
  return (
    <div className="comparator-info-section text-gray-darker col-xs-12 col-lg-8 px-0">
      <ContentCollapse
        minHeight="130px"
        isEclipseFade={false}
        btnClasses="px-0_5 py-0 size-16 text-primary-darker"
        btnContainerClasses="py-0"
        justify="justify-content-start"
        showBtnBelow
        btnTextClasses="fw-normal"
        classes="size-16"
      >
        <p className="size-16">
          Trying to figure out which car, truck, or SUV you should buy? Deciding between multiple vehicles can be a
          chore if you don&#39;t have the right tools, so let the experts at Edmunds do the heavy lifting. Just select
          the cars you&#39;re interested in from our comprehensive list, and we&#39;ll take care of the rest.
        </p>

        <p className="size-16">
          Our powerful car comparison tool lets you compare multiple vehicles, so you can see how they stack up at a
          glance. Compare features, warranties, engines, fuel economy, passenger room and trunk space, and even
          ownership costs. See ratings and pros and cons for each vehicle, and compare not just MSRP but what people are
          actually paying and dealer invoice prices. You can compare competitive vehicles, or compare different trim
          levels or model years of the same car.
        </p>

        <p className="size-16 mb-0">
          Our comparator isn&#39;t just about figuring out which car is better, it&#39;s about figuring out which car is
          best for you. Compare more than fifty easy-to-read data points, and find out what our editors and users think
          of each vehicle on your list.
        </p>
      </ContentCollapse>
    </div>
  );
}
